import { render } from "./InvoicesView.vue?vue&type=template&id=b5e7897e"
import script from "./InvoicesView.vue?vue&type=script&lang=js"
export * from "./InvoicesView.vue?vue&type=script&lang=js"

import "./InvoicesView.vue?vue&type=style&index=0&id=b5e7897e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__